<template>
    <div class="criar-acessorios-form">
        <!-- Loading -->
        <loading />

        <form
            @submit.prevent="sendData(routine)"
            class="form-module admin-backoffice-form"
            method="post"
            action=""
            aria-describedby="Create Customer Card Plans"
            enctype="application/x-www-form-urlencoded"
            autocomplete="on"
        >
            <div class="input-row">
                <!-- Nome -->
                <div class="input-row-item">
                    <div data-reference="name" class="item-label-input">
                        <label for="name" class="form-label body-1 strong-600"
                            >Nome</label
                        >
                        <input
                            type="text"
                            @focusin="inputValidationCase('name')"
                            @focusout="inputValidationCase('name')"
                            v-model="name"
                            class="form-control"
                            id="name"
                            placeholder="Nome"
                            maxlength="150"
                        />
                    </div>
                </div>

                <!-- Icons -->
                <div class="input-row-item icons-row-item">
                    <p class="body-1 strong-600">Icons</p>

                    <template v-if="customData.length > 0">
                        <ul class="selected-list icons-list">
                            <li
                                v-for="(value, index) in customData"
                                :key="value.id"
                                :data-refereindex="index"
                                :data-id="value.id"
                                data-indicate="icons"
                                @click="
                                    chooseItems(
                                        $event,
                                        iconsSelected,
                                        customData
                                    )
                                "
                                class="list-group-item acessorios-list-group-item"
                            >
                                <span
                                    :data-refereindex="index"
                                    :data-id="value.id"
                                    data-indicate="icons"
                                    class="body-1"
                                    >
                                    <img :src=" `${iconimgpath}/${value.icon}.svg`" :alt="value.name">
                                </span
                                >
                            </li>
                        </ul>
                    </template>
                </div>

                <!-- Description -->
                <div class="input-row-item icons-row-item">
                    <div data-reference="description" class="item-label-input">
                        <label
                            for="description"
                            class="form-label body-1 strong-600"
                            >Descrição</label
                        >
                        <textarea
                            class="form-control"
                            @focusin="inputValidationCase('description')"
                            @focusout="inputValidationCase('description')"
                            v-model="description"
                            placeholder="Escrever descrição"
                            id="description"
                            maxlength="400"
                        >
                        </textarea>
                    </div>
                </div>

                <!-- Add img -->
                <div class="input-row-item icons-row-item">
                    <div class="add-image-wrapper">
                        <div class="add-img">
                            <label
                                for="accessorie_image"
                                class="form-label body-1 strong-600"
                                >Add Images</label
                            >
                            <input
                                @change="
                                    multipleFileData($event, 'accessorie_image')
                                "
                                class="form-control input-file-account"
                                name="files"
                                type="file"
                                id="accessorie_image"
                                accept="image/*"
                                ref="accessorie_image"
                                data-filealt="accessorie_image"
                                multiple
                            />
                        </div>

                        <div class="baseimage_preview"></div>
                    </div>
                </div>

                <div class="btns-wrapper">
                    <button
                        type="submit"
                        class="btn btn-primary btnsubmit button-body"
                        :disabled="disabled"
                    >
                        {{
                            routine === "PUT"
                                ? "Editar acessorio"
                                : "Criar acessorio"
                        }}
                    </button>

                    <button
                        @click="turnBack(moduledefaultindex)"
                        type="button"
                        class="btn btncancel button-body"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </form>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>
</template>
<script>
import fetchData from "./../../../fetchData.js";
import htmlElements from "./../../../htmlElements";
import inputValidation from "./../../../validationInputs.js";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import responseMessage from "./../../../responseMessage.js";
import CardElement from "./../../elements/CardElement.vue";

//Set Use Strict
("use strict");

export default {
    name: "AccessorieForm",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routine: {
            type: String,
            required: true,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: Array,
            required: true,
        },
        customdata: {
            type: Array,
            required: false,
        },
        imgdefaultaccount: {
            type: String,
            required: false,
        },
        iconimgpath:{
            type: String,
            required: true,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            name: "",
            description: "",
            disabled: true,
            inputNotIsValid: true,
            activeclass: "d-flex",
            moduleData: [],
            customData: [],
            alertmegabyte: 1024 * 1000 * 1.2,
            filedataformlist: [],
            filedataformitemlist: {},
            filewidthheightlist: [],
            filedataformlistMediaData: [],
            iconsSelected: [],
            quantityofimages: 10,
            responseTimeOut: 5000,
        };
    },
    created() {
        //Set Data
        this.moduleData = this.moduledata;
        this.customData = this.customdata;
    },
    mounted() {
        //Set Values for Update Routine
        this.setValuesForUpdate(this.moduleData);

        /*  window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        }); */
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        turnBack(referurl) {
            defaultWebsite.turnBack(referurl);
        },
        chooseItems(element, selectedlist, referlist) {
            //Get Data from element
            let referElement = element.currentTarget;

            //Get Refer Index
            let referIndex = parseInt(
                referElement.getAttribute("data-refereindex")
            );

            //Enabled Button
            this.disabled = false;

            //Add Class and Push
            if (selectedlist.length === 0) {
                //Push Element
                selectedlist.push(referlist[referIndex]);

                //Selected
                referElement.classList.add("selected");
            } else {
                //Get Id
                let id = parseInt(referElement.getAttribute("data-id"));

                //Get Value from referList
                let indicateValue = selectedlist.find(
                    (value) => value.id === id
                );

                //Get Index
                let indexValue = "";

                if (indicateValue === undefined) {
                    //Check Type of List
                    switch (referElement.getAttribute("data-indicate")) {
                        //Location
                        case "icons":
                            //Get Parent Element
                            let referElementList = referElement.parentElement;

                            //Remove all selected class
                            [...referElementList.children].forEach((val) =>
                                val.classList.remove("selected")
                            );

                            //Get Index
                            selectedlist.forEach(
                                (value, index) => (indexValue = index)
                            );

                            //Remove from List
                            selectedlist.splice(indexValue, 1);

                            //Push Element
                            selectedlist.push(referlist[referIndex]);

                            //Selected
                            referElement.classList.add("selected");

                            break;
                    }
                } else {
                    //Get Index
                    selectedlist.forEach((value, index) => {
                        if (value.id === id) {
                            indexValue = index;
                        }
                    });

                    //Remove from List
                    selectedlist.splice(indexValue, 1);

                    //Unselected
                    referElement.classList.remove("selected");
                }
            }
        },
        inputValidationCase(inputid) {
            //console.log(Object.entries(this.$data));

            //Check Inputs
            switch (inputid) {
                //name
                case "name":
                    this.disabled = inputValidation.validNameCases(4, this.name)
                        ? false
                        : true;

                    break;

                //description
                case "description":
                    if (
                        this.description !== "" &&
                        this.description.length <= 400
                    ) {
                        this.disabled = inputValidation.validNameCases(
                            4,
                            this.description
                        )
                            ? false
                            : true;
                    }

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },

        setValuesForUpdate(moduleData) {
            //Check Routine
            if (this.routine === "POST") {
                return;
            }

            //Set Value
            this.name = moduleData[0].name;
            this.description = moduleData[0].description
                ? moduleData[0].description
                : "";

            //Set Data
            if (moduleData[0].data !== null) {
                moduleData[0].data = JSON.parse(moduleData[0].data);

                this.setUpdateValuesPerList(
                    "icons",
                    "icons-list",
                    moduleData[0].data,
                    this.iconsSelected,
                    this.customData
                );
            }

            //Check by Media Data
            if (Array.isArray(moduleData[0].media_id)) {
                moduleData[0].media_data.forEach((value, index) => {
                    //Create Image
                    let img = this.createImage(`preview_${index}`);

                    //Set src
                    img.setAttribute(
                        "src",
                        value[0].thumbexist
                            ? value[0].media_thumb
                            : value[0].media_original
                    );

                    //Set Preview Image Content
                    document
                        .querySelector(".baseimage_preview")
                        .appendChild(img);
                });
            }

            //Set Conditional
            this.inputNotIsValid = false;

            //Enabled Submit Button
            this.disabled = false;
        },
        setUpdateValuesPerList(
            indicate,
            list,
            updatevalue,
            selectList,
            referList
        ) {
            //Check List
            if (!Array.isArray(updatevalue)) {
                return;
            }

            //Check Indicate
            switch (indicate) {
                case "icons":
                    //Set Selected Item
                    [...document.querySelector(`.${list}`).children].forEach(
                        function (value) {
                            if (
                                parseInt(value.getAttribute("data-id")) ===
                                updatevalue[0].id
                            ) {
                                //Add selected class
                                value.classList.add("selected");
                            }
                        }
                    );

                    //Push Value
                    selectList.push(
                        referList.find((val) => val.id === updatevalue[0].id)
                    );

                    break;
            }
        },
        createImage(inputid, height = "76", width = "76") {
            //Create LI Element
            return htmlElements.createElement("img", {
                class: `preview_${inputid}`,
                id: `preview_${inputid}`,
                src: "",
                height: height,
                width: width,
                alt: "preview",
                style: "object-fit: cover;",
            });
        },
        multipleFileData(element, inputid) {
            //Check Routine
            if (this.routine === "PUT") {
                //Send Confirmation
                let confirmChangeImg = confirm(
                    "Ao mudar as imagens irá remover as antigas. Deseja Proceder ?"
                );

                //Check Confirmation
                if (!confirmChangeImg) {
                    return;
                }
            }

            //Set Disabled
            element.target.setAttribute("disabled", true);

            //FileData Item Object Clean Variable
            this.filedataformitemlist = {};
            this.filewidthheightlist = [];
            this.filedataformlist = [];

            //Clean Old Preview Images
            [...document.querySelector(".baseimage_preview").children].forEach(
                (value) => value.remove()
            );

            //Get Data from File
            let filedata = element.target.files;

            //Check quantity of files
            if (filedata.length >= this.quantityofimages) {
                alert(
                    "Nosso sistema apenas permite até 10 imagens por upload."
                );

                //Enabled Input
                element.target.removeAttribute("disabled");

                return;
            }

            //Get Data from Multiple File
            [...filedata].forEach((value, index) => {
                //Check fileSize
                if (value.size >= Math.abs(this.alertmegabyte)) {
                    alert("Please upload a smaller file up to 1MG");

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    //Disabled Submit button
                    //this.disabled = true;

                    return;
                }

                //Check type of the file
                if (!value.type.includes("image")) {
                    alert("Please only send image type file");

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    return;
                }

                //Structure File Data Object
                this.filedataformitemlist = {
                    fileindex: index,
                    filename: value.name.trim(),
                    filedata: {},
                };

                //Create Image Element
                let img = this.createImage(inputid + "_" + index);

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (e) => {
                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                        //Set FileDimension
                        let filedimension = {
                            width: img.width,
                            height: img.height,
                        };

                        //Set File width and height
                        this.filewidthheightlist.push(filedimension);

                        return this.filewidthheightlist;
                    };

                    img.onerror = (error) => {
                        throw new Error(error);
                    };

                    img.src = src;
                };

                //Create Event Listenner for render image
                reader.addEventListener(
                    "load",
                    () => {
                        // convert image file to base64 string
                        img.src = reader.result;

                        //Set Preview Image Content
                        document
                            .querySelector(".baseimage_preview")
                            .appendChild(img);
                    },
                    false
                );

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(value);

                //Get Data from Promise
                this.filedataformitemlist.filedata = file64Promise
                    .then((val64) => {
                        //Structure File Data Object
                        let filedata = {
                            type: value.type.replace("image/", ""),
                            filealt: value.name.trim(),
                            file64: val64,
                            filename: value.name.trim(),
                        };

                        //Check Old Image Data and remove old image data
                        //this.oldImageUpdateRoutine(element.target.getAttribute('data-storeid'), this.filedataformitemlist.filedata);

                        //Remove Disabled Attribute
                        element.target.removeAttribute("disabled");

                        //Send Data for Storage File
                        return filedata;
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });

                //Push Data
                this.filedataformlist.push(this.filedataformitemlist);
            });

            //Check FileData
            if (this.filedataformlist.length > 0) {
                this.filedataformlist.forEach((value, index) => {
                    //Set Filedimension
                    this.filedataformlist[index].filedimension =
                        this.filewidthheightlist[index];

                    //Get FileData from Promise
                    value.filedata
                        .then((valfile) => {
                            //Replace Object
                            this.filedataformlist[index].filedata = valfile;
                        })
                        .catch((error) => {
                            throw new Error(error);
                        });
                });
            }

            //Enabled Button
            this.disabled = false;
        },
        oldImageUpdateRoutine(storeid, newimgdata) {
            //Check Old Image Data
            if (
                this.routine === "PUT" &&
                this.filedataformlistMediaData.length > 0
            ) {
                //Index old image
                //let indexOldImg = null;

                this.filedataformlistMediaData.forEach(
                    (valoldimg, indexoldimg) => {
                        if (valoldimg.media.store_id === parseInt(storeid)) {
                            //indexOldImg = indexoldimg;

                            //Update FileData
                            valoldimg.filedata.newimg = newimgdata;
                        }
                    }
                );

                /* if(indexOldImg !== null){

                    //Remove old data from FileData
                    this.filedataformlistMediaData.splice(indexOldImg, 1);

                } */
            }
        },
        sendData(method) {
            //When the input is empty
            if (this.name === "" || this.iconsSelected.length === 0) {
  
                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Todos os campos com * são de preenchimento obrigatório",
                    this.activeclass
                );

                this.disabled = true;

                return this.disabled;
            }

            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            let dataForm = {
                name: this.name.trim(),
                description:
                    this.description !== "" ? this.description.trim() : null,
                data: this.iconsSelected.length > 0 ? this.iconsSelected : null,
                filedata:
                    this.filedataformlist.length > 0
                        ? this.filedataformlist
                        : null,
            };

            //Check Routine
            if (this.routine === "PUT") {
                dataForm.id = this.moduleData[0].id;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                dataForm,
                this.csrftolken,
                this.routine
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname
                    );

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Check Response
                    if (Object.is(value.classname, "success")) {
                        //Redirect for Module Index
                        window.location.replace(this.moduleindex);
                    }

                    //Enabled Button
                    this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedDisabled() {
            return this.disabled;
        },
        computedInputIsNotValid() {
            return this.inputNotIsValid;
        },
        computedFiledataFormList() {
            return this.filedataformlist;
        },
        computedFileFormItemList() {
            return this.filedataformitemlist;
        },
        computedFileWidthHeightList() {
            return this.filewidthheightlist;
        },
        computedIconsSelected() {
            return this.iconsSelected;
        },
    },
    watch: {
        computedDisabled() {},
        computedInputIsNotValid() {},
        computedFiledataFormList() {},
        computedFileFormItemList() {},
        computedFileWidthHeightList() {},
        computedIconsSelected() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        cardElement: CardElement,
    },
    beforeDestroy() {
        this.name = "";
        this.address = "";
        this.postalcode = "";
        this.complement = "";
        this.observation = "";
        this.user_rule = "";
    },
};
</script>
